import { useParams } from 'react-router-dom';
import { IChainTrendingCoin, ITokenInfo } from '@kattana-io/common';
import { ErrorBoundary } from 'react-error-boundary';
import TokenPairsTable from './TokenPairsTable';
import TokenNews from '../../../components/SEO/mobile/News';
import TokenAbout from '../../../components/SEO/mobile/About';
import TokenTrendingCoins from '../../../components/SEO/mobile/TrendingCoins';
import { getPriceUSD, getTokenStatistics } from '../helpers';
import Fallback from '../../../components/Fallback';
import { getPriceChange } from '../../../helpers/priceChange';

import '../../../components/SEO/mobile/styles.scss';

interface ITokenProps {
  token: ITokenInfo;
  trendingCoins: Record<string, IChainTrendingCoin> | null;
}

const TokenMobile = ({ token, trendingCoins }: ITokenProps) => {
  const params = useParams();

  const priceUSD = getPriceUSD(params.address || '', token.pairs?.[0]);

  const { priceChangePercent } = getPriceChange(priceUSD, token.pairs?.[0]);

  return (
    <div className='mobile_seo_page__content'>
      <ErrorBoundary
        fallbackRender={(props) => (
          <Fallback
            {...props}
            className='mobile_seo_page__about_token'
            title='About Token Section'
          />
        )}
        onReset={(details) => {
          // Reset the state of your app so the error doesn't happen again
        }}
      >
        <TokenAbout
          title={token.long_title}
          subTitle={token.title}
          slug={token.slug}
          logo={token.logo_url}
          priceUSD={priceUSD}
          priceChange={priceChangePercent}
          description={token.seo_text || ''}
          chain={params.chain}
          address={params.address}
          converterTitle={`${token.title} Converter`}
          statisticsTitle={`${token.title} Price Statistics`}
          statistics={getTokenStatistics(token, priceUSD)}
        />
      </ErrorBoundary>
      <ErrorBoundary
        fallbackRender={(props) => (
          <Fallback
            {...props}
            className='mobile_seo_page__table'
            title='Token Pairs Table'
          />
        )}
        onReset={(details) => {
          // Reset the state of your app so the error doesn't happen again
        }}
      >
        <TokenPairsTable title={`${token.title} Markets`} pairs={token.pairs} />
      </ErrorBoundary>
      {token.news && token.news?.length > 0 && (
        <ErrorBoundary
          fallbackRender={(props) => (
            <Fallback
              {...props}
              className='mobile_seo_page__news'
              title='Token News'
            />
          )}
          onReset={(details) => {
            // Reset the state of your app so the error doesn't happen again
          }}
        >
          <TokenNews news={token.news} />
        </ErrorBoundary>
      )}
      {trendingCoins && (
        <ErrorBoundary
          fallbackRender={(props) => (
            <Fallback
              {...props}
              className='mobile_seo_page__trending'
              title='Trending Coins'
            />
          )}
          onReset={(details) => {
            // Reset the state of your app so the error doesn't happen again
          }}
        >
          <TokenTrendingCoins
            coins={trendingCoins}
            chain={params.chain || ''}
            address={params.address || ''}
          />
        </ErrorBoundary>
      )}
    </div>
  );
};

export default TokenMobile;
